import {ViewPersonalConfig} from "../../@type";
import {ViewType} from "../../../../gd/const/views/view-type";
import {PersonalViewLocation} from "../@types";

export const MY_WORK_CONFIG : ViewPersonalConfig = {
    type            : ViewType.MY_WORK,
    name            : 'My Work',
    icon            : 'i5-my-work-new',
    iconSvg         : '',
    url             : 'my-work',
    description     : '',
    defaultLocation : PersonalViewLocation.HOME
}
